__turbopack_context__.v({
  "label": "CartLineItem-module__pUILRW__label",
  "price": "CartLineItem-module__pUILRW__price",
  "row": "CartLineItem-module__pUILRW__row",
});
